import { isDiscounted } from "@modules/shared/utils/utils";
import { ProductPrice } from "@shopify/hydrogen-react";
import { cn } from "@ui/lib/utils";
import type { MoneyV2, Product } from "@shopify/hydrogen-react/storefront-api-types";

type Props = {
  product:
    | Product
    | {
        priceRange: {
          minVariantPrice: MoneyV2;
        };
        compareAtPriceRange: {
          maxVariantPrice: MoneyV2;
        };
      };
  hidePrice?: boolean;
  isDarkBackground?: boolean;
  productPriceClassName?: string;
};

export const PriceDisplay: React.FC<Props> = ({
  hidePrice,
  product,
  isDarkBackground,
  productPriceClassName = "",
}) => {
  // const isCroatian = locale === 'hr';
  return !hidePrice ? (
    <div className="flex flex-col gap-[5px] font-primary">
      <div
        className={cn(
          "flex gap-2 text-medium max-mobile:text-small",
          productPriceClassName
        )}
      >
        {isDiscounted(
          product.priceRange.minVariantPrice,
          product.compareAtPriceRange.maxVariantPrice
        ) && (
          <ProductPrice
            data={product}
            priceType="compareAt"
            valueType="max"
            className="text-text-4 line-through"
            suppressHydrationWarning
          />
        )}
        <ProductPrice
          data={product}
          className={cn(isDarkBackground ? "text-text-5" : "text-text-3")}
          suppressHydrationWarning
        />
      </div>
      {/* {isCroatian && (
        <div
          className={cltm(
            'text-tny -tracking-[0.02em]',
            isDarkBackground ? 'text-text-5' : 'text-text-3',
          )}
        >
          (
          <Money
            data={{
              amount: (
                Number(product.priceRange.minVariantPrice.amount) *
                HRKconversion
              ).toString(),
              currencyCode: 'HRK',
            }}
            as="span"
            suppressHydrationWarning
          />
          )
        </div>
      )} */}
    </div>
  ) : null;
};
